var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-maps-page"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('vuestic-widget',{staticClass:"google-maps-page__widget",attrs:{"headerText":"Google Maps"}},[_c('google-map')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }